// extracted by mini-css-extract-plugin
export default {"page":"hQ","headerwrap":"iQ","headerblock":"jQ","textwrapper":"kQ","text":"lQ","closerlook":"mQ","arrowwrap":"nQ","icon":"oQ","updown":"pQ","products":"qQ","system":"rQ","systemimage":"sQ","cards":"tQ","note":"uQ","fadein":"vQ"};
    if(module.hot) {
      // 1711394579192
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  